"use client";

import { Box, Container, Typography } from "@mui/material";
import Image from "next/image";
import { useEffect } from "react";
import posthog from "posthog-js";
import GeneralErrorImage from "../assets/images/error.png";

export interface ErrorScreenProps {
  error: Error & { digest?: string };
  errorMessage?: string;
  action?: React.ReactNode;
  imageSrc?: string;
}

export const ErrorScreen = ({
  error,
  errorMessage = "Oops we’ve hit a snag! We apologize for the inconvenience. Please refresh the page or check back again at a later time.",
  action,
  imageSrc = GeneralErrorImage.src,
}: ErrorScreenProps) => {
  useEffect(() => {
    if (error) {
      posthog.captureException(error);
    }
  }, [error]);

  return (
    <Container
      sx={{
        height: "100%",
        width: "100%",
      }}
    >
      <Box
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: 7,
        }}
      >
        <Image
          alt="Resource not found"
          height={456}
          src={imageSrc}
          width={456}
        />
        <Typography variant="headingH6">{errorMessage}</Typography>
        {action}
      </Box>
    </Container>
  );
};
